import React, { Component } from "react";
import Search from "../../../../common/components/search-text/search-text";
import Button from "../../../button-classic/button-classic";
import { connect } from "react-redux";
import ACTIONS from "../../../../common/action_constant";
import Delete from "../../../../assets/images/delete.svg";
import Edit from "../../../../assets/images/edit.svg";
import { withRouter } from "react-router-dom";
import AddSapMaster from "./add-sap-master";
import { getItemFromSessionStorage } from "Utils/sessionStorage";
import { getEmail, getUserId } from "Utils/common";

class SapMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      offset: 0,
      limit: 10,
      sapData: [],
      count: 10,
    };
  }
  componentDidMount() {
    this.getSapMasterData();
    this.getSapMasterInterFaceData()
  }

  getSapMasterData() {
    const { dispatch, companyId } = this.props;
    const { search, offset, limit } = this.state;
    let param = `?companyId=${companyId}&limit=${limit}&offset=${offset}`;
    if (search) {
      param += `&search=${search}`;
    }
    dispatch({
      type: ACTIONS.PLANTS.GET_SAP_LIST_MASTER,
      param,
      onSuccess: (res) => {
        this.setState({ sapData: res && res.list });
      },
    });
  }

  getSapMasterInterFaceData() {
    const { dispatch} = this.props;
    dispatch({
      type: ACTIONS.PLANTS.GET_SAP_MASTER_INTERFACE,
      onSuccess: (res) => {
        this.setState({ sapInterFaceData: res && res.list });
      },
    });
  }

  changeHandler = (value) => {
    this.setState({ search: value });
  };

  toggleAdd = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen, editData: "" });
  };

  onSaveSapMasterData = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.ADD_SAP_MASTER,
      data,

      onSuccess: () => {
        this.setState({ isOpen: false }, this.getSapMasterData());
      },
    });
  };

  onSearch = () => {
    this.setState({ offset: 0 }, this.getSapMasterData);
  };

  onUpdateSapMasterData = (data) => {
    const previousData = getItemFromSessionStorage("previousSapData");
    previousData["update_flag"] = true;
    previousData["user_email"] = getEmail();
    previousData["user_id"] = getUserId();
    const { dispatch } = this.props;
    const payload = {
      ...data,
      previous_data: previousData,
    };
    dispatch({
      type: ACTIONS.PLANTS.UPDATE_SAP_MASTER,
      data: payload,
      onSuccess: () => {
        this.setState({ isOpen: false, editData: "" }, this.getSapMasterData);
      },
    });
  };

  editSapMaster = (data) => {
    this.setState({
      editData: data,
      isOpen: true,
    });
  };

  deleteSapMaster = (data) => {
    const { dispatch } = this.props;
    dispatch({
      type: ACTIONS.PLANTS.DELETE_SAP_MASTER,
      data: data,
      onSuccess: () => {
        this.getSapMasterData();
      },
    });
  };

  previous = () => {
    if (this.state.offset >= this.state.limit) {
      this.setState(
        (prevState) => ({
          offset: prevState.offset - prevState.limit,
        }),
        this.getSapMasterData
      );
    }
  };

  next = () => {
    this.setState(
      (prevState) => ({
        offset: prevState.offset + prevState.limit,
      }),
      this.getSapMasterData
    );
  };

  clearFilterOnCancel = () => {
    this.setState({ search: "", offset: 0 }, this.getSapMasterData);
  };

  handleOnClickForAuditBtn = () => {
    const { history, companyId } = this.props;
    const masterType = 58;
    const navUrl = `/auditScreen/${companyId}/${masterType}`;
    history.push(navUrl);
  };

  render() {
    const { sapData } = this.state;
    const { zones, countryListData, routeCodeList } = this.props;
    return (
      <div className={"location-network"}>
        <div>
          <div style={{ display: "block", paddingBottom: "15px" }}>
            <Search
              id="search"
              value={this.state.search}
              placeholder="Search..."
              changeHandler={this.changeHandler}
              click={this.onSearch}
              canClear={this.state.search !== ""}
              handleClearFilter={this.clearFilterOnCancel}
            />
            <Button value={"+ Add Sap Configuration"} click={this.toggleAdd} />
            <button
              className="button-classic"
              onClick={this.handleOnClickForAuditBtn}
            >
              Audit
            </button>
          </div>
        </div>
        <table className="custom-sap-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Url</th>
              <th>User Name</th>
              <th>Password</th>
              <th>Client</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {(sapData || []).map((sap, sIndex) => (
              <tr key={`route_${sIndex}`}>
                <td>{sap.name}</td>
                <td>{sap.url}</td>
                <td>{sap.username}</td>
                <td>
                  {sap.password
                    ? sap.password.replace(
                        /^(.{2})(.*)(.{2})$/,
                        (_, first, middle, last) =>
                          first + "*".repeat(middle.length) + last
                      )
                    : ""}
                </td>
                <td>{sap.client}</td>

                <td>
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Edit})` }}
                    onClick={() => this.editSapMaster(sap)}
                  />
                  <div
                    className="action-icon"
                    style={{ backgroundImage: `url(${Delete})` }}
                    onClick={() => this.deleteSapMaster(sap)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="submit-section-pagination">
          <div className="next">
            <Button value="Next" click={this.next} />
          </div>
          <div className="pre">
            <Button value="Previous" click={this.previous} />
          </div>
        </div>
        {this.state.isOpen && (
          <AddSapMaster
            toggleAdd={this.toggleAdd}
            onSave={this.onSaveSapMasterData}
            companyId={this.props.companyId}
            editData={this.state.editData}
            onUpdate={this.onUpdateSapMasterData}
            zones={zones}
            countryListData={countryListData}
            routeCodeList={routeCodeList}
            sapInterFaceData={this.state.sapInterFaceData}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zones: state.plantsDepots.zones,
    countryListData: state.master.countryList,
    productList: state.master.itemList,
    routeCodeList: state.home.routeCodes || [],
  };
};

export default connect(mapStateToProps)(withRouter(SapMaster));
